/** Local GraphQL enums — avoid importing the generated backend module into hot paths. */
export enum SortNulls {
  NullsFirst = "NULLS_FIRST",
  NullsLast = "NULLS_LAST",
}

export enum SortDirection {
  Asc = "ASC",
  Desc = "DESC",
}
